module.exports = __webpack_public_path__ + "img/free-99.a6ebe5f4.jpg";